export default __webpack_public_path__ + "static/award1-62cdaf69c6c0ec86a9f67271ef185ac8.jpg";